import { httpsCallable } from "firebase/functions";
import { functions } from "@/lib/firebase";
import type { SupportStaffRequest } from "@/types/support";

const supportStaffFn = httpsCallable<SupportStaffRequest, unknown>(functions, "supportStaff");

/** The one BiG-Support staff callable (functions/src/support/supportStaff.ts). */
export async function callSupportStaff<T = unknown>(request: SupportStaffRequest): Promise<T> {
  const result = await supportStaffFn(request);
  return result.data as T;
}

const FALLBACK_MESSAGE = "Something went wrong. Try again.";

// When the server fails before our code runs, the SDK's message is just the bare code ("internal"),
// which is not written for people. A real server message under any code still shows.
const BARE_CODE_TEXTS = new Set(["internal", "unavailable", "deadline-exceeded", "unknown", "cancelled"]);

/** The server's HttpsError message, written for people, or a fallback. */
export function supportErrorMessage(err: unknown): string {
  const message = (err as { message?: unknown } | null)?.message;
  if (typeof message !== "string" || !message.trim()) return FALLBACK_MESSAGE;
  return BARE_CODE_TEXTS.has(message.trim().toLowerCase()) ? FALLBACK_MESSAGE : message;
}
